<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";
import { MailMjmlColumn } from "#components";

const props = defineProps(nodeViewProps);
const store = useMailStore();
const frame = ref<HTMLIFrameElement>();
const theme = computed(() => {
    const collection = store.fieldCollection;

    return collection.replaceContent({
        timestamp: Date.now(),
        html: collection.replaceContent(`<!DOCTYPE html><html><head><style>html,body { margin: 0; padding: 0; }</style></head><body>${props.node.attrs?.html}</body></html>`),
    });
});

function onLoad() {
    frame.value.style.height = frame.value.contentWindow.document.documentElement.scrollHeight + 'px';
}
</script>

<template>
    <NodeViewWrapper class="html" :style="{
        '--link-color': theme.linkColor,
        '--link-underlined': theme.linkUnderlined ? 'underline' : 'inherit'
    }" @click.stop="store.focusedJsonId = node.attrs.id" @focusin.stop="store.focusedJsonId = node.attrs.id"
        :as="MailMjmlColumn" width="100%">
        <iframe ref="frame" class="pointer-events-none w-full" @load="onLoad" :srcdoc="theme.html"
            :key="theme.timestamp" />
    </NodeViewWrapper>
</template>